import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const Refund = () => (
  <div className="min-h-screen py-16 px-6">
    <div className="max-w-3xl mx-auto">

      {/* Hero */}
      <div className="text-center mb-12">
        <div className="inline-block p-4 bg-green-500/10 rounded-full mb-4">
          <ShieldCheck className="w-10 h-10 text-green-400" />
        </div>
        <h1 className="text-4xl font-bold text-white mb-3">Refund Policy</h1>
        <p className="text-gray-400">Last updated: April 14, 2026</p>
      </div>

      {/* Guarantee banner */}
      <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/30 rounded-2xl p-6 mb-10 text-center">
        <h2 className="text-2xl font-bold text-white mb-2">🛡️ 30-Day Satisfaction Guarantee</h2>
        <p className="text-green-300">
          If you're not happy with globalnow.biz within 30 days of purchase, we'll refund you. No questions asked.
        </p>
      </div>

      <div className="space-y-8 text-gray-400 text-sm leading-relaxed">

        <div>
          <h2 className="text-xl font-semibold text-white mb-3">Eligibility</h2>
          <p>To be eligible for a refund:</p>
          <ul className="mt-2 space-y-1 ml-4">
            <li>• Your refund request must be submitted within <strong className="text-gray-200">30 days</strong> of your original purchase date</li>
            <li>• You must contact us at <a href="mailto:support@globalnow.biz" className="text-blue-400 hover:underline">support@globalnow.biz</a> with your PayPal transaction ID</li>
            <li>• Refunds apply to Lifetime Deal purchases and annual subscriptions</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-white mb-3">How to Request a Refund</h2>
          <ol className="space-y-2 ml-4">
            <li>1. Email <a href="mailto:support@globalnow.biz" className="text-blue-400 hover:underline">support@globalnow.biz</a> with subject line: <strong className="text-gray-200">"Refund Request"</strong></li>
            <li>2. Include your account email address and PayPal transaction ID</li>
            <li>3. We will process your refund within <strong className="text-gray-200">5 business days</strong></li>
            <li>4. Refunds are returned to your original PayPal account</li>
          </ol>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-white mb-3">After a Refund</h2>
          <p>Upon processing your refund, your account will be downgraded to the free tier.
          Any websites or content you generated remain yours — we will not delete them immediately,
          but you will lose access to PRO generation features.</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-white mb-3">Exceptions</h2>
          <p>We reserve the right to deny refunds in cases of:</p>
          <ul className="mt-2 space-y-1 ml-4">
            <li>• Requests made after the 30-day window</li>
            <li>• Accounts found to be in violation of our <Link to="/terms" className="text-blue-400 hover:underline">Terms of Service</Link></li>
            <li>• Accounts with evidence of abuse (e.g., excessive generation requests designed to circumvent limits)</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-white mb-3">Questions?</h2>
          <p>
            We want you to be happy. If something isn't working as expected, please reach out before
            requesting a refund — we may be able to fix the issue immediately.
            Email <a href="mailto:support@globalnow.biz" className="text-blue-400 hover:underline">support@globalnow.biz</a> or
            chat with Mr. Support on any page.
          </p>
        </div>

      </div>
    </div>
  </div>
);

export default Refund;
